const FRENCH_E164 = /^\+33(\d{9})$/;

/**
 * Human-readable form of an E.164 number: French numbers in national format
 * (`+33670123416` → `06 70 12 34 16`), any other number unchanged.
 */
export function formatPhoneNumberForDisplay(phoneNumber: string): string {
  const match = FRENCH_E164.exec(phoneNumber);
  if (!match) return phoneNumber;
  return `0${match[1]}`.replace(/(\d{2})(?=\d)/g, '$1 ');
}
